<button mat-icon-button class="close-button" [matDialogClose]>
  <mat-icon class="close-icon" color="warn" id="meetingDialog-button-close">close</mat-icon>
</button>
<mat-card class="mat-elevation-z0">
  <mat-card-title *ngIf="this.meetingType=='company'">Request a Meeting</mat-card-title>
  <mat-card-title *ngIf="this.meetingType=='contact'" >Request a Meeting with {{selectedContact[0].value}}</mat-card-title>
  <mat-card-subtitle>
    Request a meeting with your desired contact. SalesCaddy will try to fulfill this request.</mat-card-subtitle>
  <form [formGroup]="formGroup1">
    <!--Radio Group-->
    <div class="survey-group" id="meetingDialog-radioGroup-1">
      <label class="radio-group-label">{{this.findQuestions('radioGroup1').title}}
        <span style="color: #ff0000"
              *ngIf="formGroup1.get('radioGroup1').touched && formGroup1.get('radioGroup1').invalid">
                * required
              </span>
      </label>
      <mat-radio-group class="radio-group" formControlName="radioGroup1" required>
        <ul>
          <li *ngFor="let radioButtonValue of this.findQuestions('radioGroup1').elementValue">
            <mat-radio-button class="radio-button"  color="primary"  [value]="radioButtonValue"
                              (change)="onRadioGroup1ItemChange(radioButtonValue)" >
              {{radioButtonValue}}
            </mat-radio-button>
          </li>
        </ul>
        <mat-form-field class="example-full-width" appearance="outline" *ngIf="isVisibleCustom1">
          <mat-label>Other</mat-label>
          <input matInput placeholder="Write text..." formControlName="custom1">
        </mat-form-field>
      </mat-radio-group>
    </div>
    <!--Radio Group-->
    <div class="survey-group" *ngIf="this.meetingType=='company'"  id="meetingDialog-radioGroup-2">
      <label class="radio-group-label">{{findQuestions('radioGroup2').title}}
        <span style="color: #ff0000"
              *ngIf="formGroup1.get('radioGroup1').touched && formGroup1.get('radioGroup2').invalid">
                  * required</span></label>
      <mat-radio-group class="radio-group" formControlName="radioGroup2" required>
        <ul>
          <li *ngFor="let radioButtonValue of findQuestions('radioGroup2').elementValue">
            <mat-radio-button class="radio-button"  color="primary"  [value]="radioButtonValue"
                              (change)="onRadioGroup2ItemChange(radioButtonValue)">
              {{radioButtonValue}}
            </mat-radio-button>
          </li>
        </ul>
        <mat-form-field class="example-full-width" appearance="outline" *ngIf="isVisibleCustom2">
          <mat-label>Other</mat-label>
          <input matInput placeholder="Write text..." formControlName="custom2">
        </mat-form-field>
      </mat-radio-group>
    </div>
    <!--Radio Group-->
    <div class="survey-group" *ngIf="this.meetingType == 'company'" id="meetingDialog-radioGroup-3">
      <label class="radio-group-label">{{findQuestions('radioGroup3').title}}</label>
      <mat-radio-group class="radio-group" formControlName="radioGroup3">
        <ul>
          <li *ngFor="let radioButtonValue of findQuestions('radioGroup3').elementValue">
            <mat-radio-button class="radio-button"  color="primary"  [value]="radioButtonValue"
                              (change)="onRadioGroup3ItemChange(radioButtonValue)">
              {{radioButtonValue}}
            </mat-radio-button>
          </li>
        </ul>
        <div *ngIf="isVisibleCustom3">
          <chips-autocomplete-input  formControlName="custom3" [onlySingle]="true" [allowedNew]="true"
                                     [values]="contacts" (onChanged)="findContacts($event.searchQuery)"
                                     [required]="true"></chips-autocomplete-input>
        </div>
      </mat-radio-group>
    </div>
  </form>
  <mat-card-content>
  </mat-card-content>
  <mat-card-actions align="end">
    <button mat-raised-button color="primary" (click)="bookMeeting()"
            [disabled]="!formGroup1.valid"  id="meetingDialog-button-requestMeeting">Request Meeting</button>
  </mat-card-actions>
</mat-card>
